<template>
  <crm-side-panel @handleClose="handleCloseDetail" :title="row.contractNo">
    <div class="side-panel-content compact-detail-content">
      <div class="side-panel-header">
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">合同名称</p>
            <p class="info-detail">{{ row.contractName || compactDetail.htmc }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">客户名称</p>
            <p class="info-detail">{{ row.customerName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">合同金额(元)</p>
            <p class="info-detail">{{ row.contractAmount || compactDetail.htjexx }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">已收款金额(元)</p>
            <p class="info-detail">{{ row.refundAmount || compactDetail.refundAmount }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">{{ row.salesmanName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员所属团队</p>
            <p class="info-detail">{{ row.teamName || compactDetail.teamName }}</p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" @tab-click="handleClick" :stretch="false">
          <!-- 合同信息tab页 -->
          <el-tab-pane label="合同信息" name="compactInfo" :loading="loading">
            <pane-info
              :contractModule="contractModule"
              :detail="compactDetail"
              :row="row"
            ></pane-info>
          </el-tab-pane>
          <!-- 对方公司tab页 -->
          <el-tab-pane
            label="对方公司"
            name="oppositeCompany"
          >
            <opposite-company ref="oppositeCompany" :id="detailId"/>
          </el-tab-pane>
          <!-- 押金/保证金 -->
          <el-tab-pane
            label="押金/保证金"
            name="deposit"
          >
            <deposit ref="deposit" :id="detailId"/>
          </el-tab-pane>
          <!-- 开票记录tab页 -->
          <el-tab-pane
            label="开票记录"
            name="billsRecord"
            v-if="
              contractAuth.contractReceivable &&
              contractAuth.contractReceivable.toggleStatus
            "
          >
            <bills-record ref="billsRecord" :id="detailId" :info="row" :detail="compactDetail"/>
          </el-tab-pane>
          <!-- 收款记录tab页 -->
          <el-tab-pane
            label="收款记录"
            name="returnRecord"
          >
            <return-record ref="returnRecord" :id="detailId" :info="row"/>
          </el-tab-pane>
          <!-- 验收记录 -->
          <el-tab-pane
            label="验收记录"
            name="acceptanceRecord"
          >
            <acceptance-record ref="acceptanceRecord" :id="detailId" :info="row" :detail="compactDetail"/>
          </el-tab-pane>
          <!-- 成本tab页 -->
          <el-tab-pane
            label="成本"
            name="cost"
            v-if="contractAuth.costTab && contractAuth.costTab.toggleStatus"
          >
            <cost ref="cost" :id="detailId"/>
          </el-tab-pane>
          <!-- 费用tab页 -->
          <el-tab-pane
            label="费用"
            name="pay"
            v-if="contractAuth.contractFee && contractAuth.contractFee.toggleStatus"
          >
            <pay ref="pay" :id="detailId"/>
          </el-tab-pane>
          <!-- 异常提报记录 -->
          <el-tab-pane
            label="异常提报记录"
            name="abnormalReporting"
          >
            <abnormal-reporting ref="abnormalReporting" :id="detailId"/>
          </el-tab-pane>
          <!-- 调档记录 -->
          <el-tab-pane
            label="调档记录"
            name="shiftRecord"
          >
            <shift-record ref="shiftRecord" :id="detailId"/>
          </el-tab-pane>
          <!-- 续签协议 -->
          <el-tab-pane
            label="续签协议"
            name="renewalAgreement"
          >
            <renewal-agreement ref="renewalAgreement" :id="detailId"/>
          </el-tab-pane>
          <!-- 补充协议 -->
          <el-tab-pane
            label="补充协议"
            name="supplementaryAgreement"
          >
            <supplementary-agreement ref="supplementaryAgreement" :id="detailId"/>
          </el-tab-pane>
          <!-- 附件tab页 -->
          <el-tab-pane
            label="附件"
            name="fileData"
            v-if="
              contractAuth.contractFileTab && contractAuth.contractFileTab.toggleStatus
            "
          >
            <file ref="fileData" :id="detailId"/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "~component/base/crmButton";
import PaneInfo from "./tabs/pane-info.vue";
import OppositeCompany from "./tabs/oppositeCompany.vue";
import Deposit from './tabs/deposit.vue'
import AbnormalReporting from './tabs/abnormalReporting.vue'
import ShiftRecord from './tabs/shiftRecord.vue'
import RenewalAgreement from './tabs/renewalAgreement.vue'
import SupplementaryAgreement from './tabs/supplementaryAgreement.vue'
import File from './tabs/file.vue';
import Cost from './tabs/cost'
import Pay from './tabs/pay'
import BillsRecord from './tabs/billsRecord'
import ReturnRecord from './tabs/returnRecord'
import AcceptanceRecord from './tabs/acceptanceRecord'

export default {
  components: {
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    OppositeCompany,
    Deposit,
    AbnormalReporting,
    ShiftRecord,
    RenewalAgreement,
    SupplementaryAgreement,
    File,
    Cost,
    Pay,
    BillsRecord,
    ReturnRecord,
    AcceptanceRecord,
  },
  props: {
    contractNumber: String,
    contractAmount: String,
    detailId: String,
    detailTabName: String,
    row: Object,
    visible: Boolean,
  },
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数且无逗号的数字"));
      } else if (value > 999999999.99) {
        callback(new Error("最大999999999.99"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      contractModule: null,
      moneyRule: {
        validator: validateMoney,
        trigger: "blur",
      },
      contractType: "",
      detail: {},
      isRefresh: false,
      busiOpportunityDetail: {},
      busiVisitData: [],
      busiFileData: [],
      activeTab: "compactInfo",
      returnOpenFrom: "",
      billsOpenFrom: "",
      billsTitle: "",
      billsId: "",
      addUpdateBillsForm: {
        invoiceAmountStr: "",
        invoiceDate: "",
        invoiceNo: "",
        remarks: "",
        detailed: [],
      },
      delBillsDetailed: [],
    };
  },
  computed: {
    ...mapGetters({
      compactDetail: "compact/compactDetail",
      contractAuth: "authority/contractAuth",
    }),
    ReturndTotalMoney() {
      let total = null;
      if (this.addUpdateReturnForm.detailed) {
        this.addUpdateReturnForm.detailed.forEach((item) => {
          if (item.refundAmountStr) {
            total += item.refundAmountStr * 100;
          }
        });
      }
      return total / 100;
    },
    BillsTotalMoney() {
      let total = null;
      if (this.addUpdateBillsForm.detailed) {
        this.addUpdateBillsForm.detailed.forEach((item) => {
          if (item.refundAmountStr) {
            total += item.refundAmountStr * 100;
          }
        });
      }
      return total / 100;
    },
  },
  watch: {
    detailId(val) {
        if(this.visible){
      this.loading = true;
      this.getAuthority({ menuUrl: "/compact/contract" });
      this.getCompactDetail({ id: val })
        .then(() => {
          if (
            this.compactDetail.contractType === "21cbef6460f249f1ba39716e60922117" ||
            this.compactDetail.contractType === "cbb006bf8d35416fb6cd28442c570f38"
          ) {
            this.contractModule = 2;
          } else if (
            this.compactDetail.contractType === "8629ff61554941f282146ce6cbba3856"
          ) {
            this.contractModule = 3;
          } else {
            this.contractModule = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.isRefresh = false;
      this.activeTab = "compactInfo";
        }
    },
    detailTabName(val) {
      if (val) {
        this.activeTab = val;
        this.handleClick({name: val})
      }
    },
  },
  methods: {
    ...mapActions({
      getCompactDetail: "compact/getCompactDetail",
      getAuthority: "authority/getAuthority",
    }),
    // 关闭弹框
    handleCloseDetail() {
      this.$emit("handleCloseDetail", this.isRefresh);
    },
    // 点击tab
    handleClick(value) {
      if (value.name !== 'compactInfo') this.$refs[value.name].queryList()
    },
  },
};
</script>

<style lang="less">
.compact-detail-content {
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.busi-dialog {
  padding: 0 30px;
  .el-form-item__label {
    float: none;
  }
}
.dialog-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.returnd-money-wrap {
  width: 100%;
  border-top: 1px dashed #cccccc;
  .returnd-money-title {
    width: 60px;
    background-color: #ffffff;
    margin-top: -12px;
  }
  .icon-delete {
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    margin-left: -130px;
    color: #f56c6c;
  }
}
.date-add-return {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}
</style>
